import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { HiTemplate } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import NodataImg from "../../assets/images/noData.png";
import Appbar from "../../components/Appbar";
import Body from "../../components/Body";
import Drawer from "../../components/Drawer";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import { getReportReasonAPI, resetgetReportReason } from "../../store/teacher-lounge/report-reason/getreportreason";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import DataGridComponent from "../../components/DataGridComponent";
import CustomGridToolbar from "../../components/CustomGridToolbarWithoutDownload";
import DeleteReportReason from "./DeleteReportReason";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PermissionGate from "../../components/PermissionGate";

export default function ReportReason() {
  const [tableData, setTableData] = useState([])
  const settingList = useSelector((state) => state?.getDetailsReportReason);
  const { result, loading } = settingList;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deleteId, setDeleteId] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [notSelectedProductModel, setNotSelectedProductModel] = useState(false);
  const handleNavigation = async (id, reportReasonData) => {
    navigate(`/edit-report-reason/${id}`, { state: { reportReasonData } });
  };
  const columns = [
    {
      field: "id",
      headerName: "Reason Id",
      filterable: false,
      sortable: false,
      width: 150,
    },
    {
      field: "reason",
      headerName: "Reason",
      sortable: false,
      width: 400,
    },
    {
      field: "reason_hn",
      headerName: "Reason (hindi)",
      sortable: false,
      width: 400,

    },
    {
      field: "update_setting",
      headerName: "Update",
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="teacher_lounge" action={"update"}>
            <Button
              color="info"
              endIcon={<EditIcon />}
              label="Available" variant="outlined"
              onClick={() => handleNavigation(row.id, row.row)}
            >
              Edit
            </Button>
          </PermissionGate>
        </>
      ),
    },
    {
      field: "delete_report_reason",
      headerName: "Delete Reason",
      filterable: false,
      sortable: false,
      width: 150,
      disableExport: true,
      renderCell: (row) => (
        <>
          <PermissionGate module="teacher_lounge" action={"delete"}>
            <Button
              endIcon={<DeleteOutlineIcon />}
              color="error"
              variant="outlined"
              style={{ marginLeft: "5px" }}
              onClick={() => {
                setNotSelectedProductModel(true);
                setDeleteId(row.id);
              }}
            >
              Delete
            </Button>
          </PermissionGate>
        </>
      ),
    },
  ];

  useEffect(() => {
    dispatch(getReportReasonAPI());
  }, [dispatch]);

  const addToCartHandler = async () => {
    navigate("/add-report-reason");
  };
  return (
    <>
      <Appbar />
      <Drawer />
      <Body>


        <Stack direction="row" spacing={1} sx={{ my: 2 }} alignItems="center">
          <HiTemplate size={30} />
          <Typography>Report reason management</Typography>
        </Stack>
        <Stack sx={{ my: 2 }} justifyContent="space-between" direction="row">
          <Stack direction="row" spacing={1}>
            <PermissionGate module="teacher_lounge" action={"create"}>
              <Button
                onClick={addToCartHandler}
                variant="contained"
              >
                Add new reason
              </Button>
            </PermissionGate>
          </Stack>
        </Stack>
        <Paper elevation={0}>
          <DataGridComponent
            sx={{
              height: 500
            }}
            getRowId={(row) => row.id}
            rows={result}
            columns={columns}
            loading={loading}
            slots={{
              noRowsOverlay: () => (
                <Box className="noData">
                  <img src={NodataImg} alt="no data found" />
                </Box>
              ),
              toolbar: CustomGridToolbar,
            }}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'linear-progress',
              },
              toolbar: {
                showQuickFilter: true,
              },
            }}
          />
        </Paper>

      </Body>
      <DeleteReportReason
        open={notSelectedProductModel}
        setOpen={setNotSelectedProductModel}
        setSelectedRow={setSelectedRow}
        id={deleteId}
      />
    </>
  );
}
